import React, { useMemo } from "react";
import {
  ButtonDropdown,
  type DropdownOption,
} from "@bloomberg/media-ui-dropdown";
import { Slider, createClasses } from "@bloomberg/media-ui-core";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./styles.module.css";
import TodayInMarketsSparklineCards from "~components/TodayInMarkets/TodayInMarketsSparklineCards/TodayInMarketsSparklineCards";
import { useTodayInMarkets } from "~context/TodayInMarketsContext";
import type { SparklineCardsProps } from "~types/sectionfront";
import { useTranslateMessage } from "~utils/i18n";

export default function MobileSparklineCards(props: SparklineCardsProps) {
  const { onChange, selectedOption: selectedOptionId } = props;
  const { categories } = useTodayInMarkets();
  const translate = useTranslateMessage();

  const selectedLabel = useMemo(
    () =>
      categories.find((category) => category.id === selectedOptionId)?.label ??
      categories[0].label,
    [categories]
  );

  const options: DropdownOption[] = useMemo(
    () =>
      categories.map((category) => ({
        displayValue: translate(category.label),
        value: category.id,
      })),
    [categories]
  );

  const onSelect = (option: DropdownOption | null | undefined) => {
    if (option?.value) {
      onChange(option.value);
    }
  };

  return (
    <div className={styles.dropDownContainer}>
      <ButtonDropdown
        selectedItemOverride={{
          displayValue: translate(selectedLabel),
          value: selectedOptionId,
        }}
        onSelect={onSelect}
        options={options}
        className={createClasses([
          styles.cardsDropdown,
          typographyStyles.coreShortTextSm,
        ])}
      />
      <Slider shadow={false}>
        <TodayInMarketsSparklineCards />
      </Slider>
    </div>
  );
}
